"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelIcon = exports.TabIcon = exports.TabsStyle = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.TabsStyle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .bp3-tab {\n    color: ", ";\n  }\n  & :hover {\n    color: ", ";\n  }\n  .bp3-tab-indicator {\n    background-color: ", ";\n  }\n  & :focus {\n    outline: none;\n  }\n  .bp3-tab[aria-selected='true'] {\n    color: ", ";\n  }\n"], ["\n  & .bp3-tab {\n    color: ", ";\n  }\n  & :hover {\n    color: ", ";\n  }\n  .bp3-tab-indicator {\n    background-color: ", ";\n  }\n  & :focus {\n    outline: none;\n  }\n  .bp3-tab[aria-selected='true'] {\n    color: ", ";\n  }\n"])), function (prop) { return prop.color && prop.color; }, function (prop) { return prop.hoverColor && prop.hoverColor; }, function (props) {
    return props.indicatorActive && props.indicatorActive;
}, function (prop) { return prop.active && prop.active; });
exports.TabIcon = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
exports.labelIcon = {
    display: 'flex',
    alignItems: 'center',
    margin: '0 5px 0 0'
};
var templateObject_1, templateObject_2;
